import { useRef, useEffect } from 'react'

export const useDeepEffect = (fn, deps) => {
    const isFirst = useRef(true);
    const prevDeps = useRef(deps);
  
    useEffect(() => {
      const isSame = prevDeps.current.every((obj, index) =>
        JSON.parse(JSON.stringify(obj)) === JSON.parse(JSON.stringify(deps[index]))
      );
  
      if (isFirst.current || !isSame) {
        fn();
      }
  
      isFirst.current = false;
      prevDeps.current = deps;
    }, [fn, deps]);
}

export const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
}

export const arraysHaveSameData = (arr1, arr2, key) => {
    if (arr1?.length !== arr2?.length) return false;
    
    const map = new Map();
    for (const obj of arr1) {
        const k = obj[key];
        map.set(k, (map.get(k) || 0) + 1);
    }
    
    for (const obj of arr2) {
        const k = obj[key];
        if (!map.has(k)) return false;

        const count = map.get(k) - 1;
        if (count < 0) return false;
        if (count === 0) map.delete(k);
        else map.set(k, count);
    }
    
    return map.size === 0;
};